export const articles = [
  {
    slug: "senator-lobby-cash",
    title: "深夜辞呈：参议员卷入游说金流案，三份未公开行程表浮出水面",
    excerpt:
      "一份在周五深夜提交的辞呈，让一桩沉寂了半年的游说金流案重新回到聚光灯下。三份从未登记在册的行程表，成为拼接时间线的第一块拼图。",
    category: "pol-scandal",
    tags: ["游说金流", "行程表", "利益冲突"],
    author: "编辑部 · 崔明",
    date: "2026-09-06",
    readTime: 11,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20editorial%20documentary%20photograph%20of%20a%20deserted%20government%20corridor%20at%20night%20with%20a%20single%20briefcase%20on%20a%20chair%2C%20dim%20amber%20overhead%20light%2C%20desaturated%20tones%2C%20slight%20film%20grain%2C%20no%20people&width=1200&height=800&seq=meiri-executive-01&orientation=landscape",
    coverAlt: "深夜政府办公楼走廊与椅上的公文包，用于政客丑闻专题配图",
    heat: 9820,
    featured: true,
    sections: [
      {
        id: "s1",
        heading: "一份不合时宜的辞呈",
        paragraphs: [
          "辞呈是在周五夜里提交的，距离例行的记者会还有不到三天。按照惯例，这类时机通常意味着当事人希望在舆论关注度最低的窗口完成离场。但这一次，文件在传递过程中被至少两个环节的职员看到，消息在当晚就流了出来。",
          "公开记录显示，该参议员在任期内曾三次以私人身份出席同一家咨询机构组织的闭门座谈，而这家机构同时为其竞选委员会提供过策略服务。三条记录在申报材料中都没有出现。",
        ],
      },
      {
        id: "s2",
        heading: "对不上的三段行程",
        paragraphs: [
          "我们把竞选委员会的公开报销单与助理排班表做了交叉对照，发现有三段时间出现了明显空缺：报销单上有交通与住宿支出，但官方日程里没有任何活动登记。",
          "这三段行程恰好对应闭门座谈的日期。值得注意的是，报销单上的陪同人员一栏被写成『随行二人』，但排班表中当时只有一名助理在岗。",
        ],
      },
      {
        id: "s3",
        heading: "还在流动的资金",
        paragraphs: [
          "更值得关注的是钱。竞选委员会在同期收到两笔来自同一注册地址的小额捐款，单笔金额刻意低于强制披露门槛。金额虽小，但接收频率与座谈时间高度重合。",
          "目前尚无法确认这两笔款项与座谈之间存在直接交易关系。我们已就上述记录向当事方办公室与咨询机构发出询问邮件，截至发稿未收到回应。",
        ],
      },
      {
        id: "s4",
        heading: "接下来该看什么",
        paragraphs: [
          "判断这类案件走向，通常有三个观察点：申报材料的补正是否发生、监管机构是否立案、以及竞选委员会是否主动退还争议款项。任何一个环节出现动作，都意味着事件进入了新阶段。",
          "我们会持续追踪这一档案，并在出现新文件时更新本页。",
        ],
      },
    ],
  },
  {
    slug: "chief-staff-leak",
    title: "幕僚长反水：一段未删减录音如何掀翻地方党部",
    excerpt:
      "二十三分五十一秒的录音，从会议室被带出后辗转过四个人的手机。它没有直接证据，却让地方党部的排兵布阵全部作废。",
    category: "pol-scandal",
    tags: ["录音", "党内斗争", "地方党部"],
    author: "编辑部 · 沈郁",
    date: "2026-08-29",
    readTime: 9,
    cover:
      "https://readdy.ai/api/search-image?query=empty%20conference%20room%20with%20a%20recorder%20on%20a%20long%20wooden%20table%2C%20cold%20morning%20light%20through%20blinds%2C%20muted%20neutral%20palette%2C%20documentary%20editorial%20style%2C%20grain&width=1200&height=800&seq=meiri-executive-02&orientation=landscape",
    coverAlt: "空会议桌上放置的录音设备，用于政客丑闻专题配图",
    heat: 8640,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "录音是怎么流出来的",
        paragraphs: [
          "录音的来源并不复杂：一场被要求『不要做记录』的闭门会议。与会者被要求把手机留在门外，但会议室里本就有一台用于远程连线的记录设备。",
          "设备存储卡在会后被取出，先交给一名助理转存，再经由党内两名中层职员之手。到第四个人手里时，文件已经出现在至少一台未加密的笔记本上。",
        ],
      },
      {
        id: "s2",
        heading: "内容为何杀伤力巨大",
        paragraphs: [
          "录音本身没有直接涉及金钱。但它记录了党内对候选人名单的分配讨论：谁的地盘要让出来、谁的资源要被砍掉，以及一个明确的时间表。",
          "对地方党部而言，这份名单原本计划在下月才公布。录音外泄意味着提前三周，所有被点名的人都有了应对时间，原本的谈判筹码瞬间贬值。",
        ],
      },
      {
        id: "s3",
        heading: "反水者的动机",
        paragraphs: [
          "多名知情者提到，幕僚长在会议前一周刚被削去了预算审批权。动机上的关联显而易见，但更值得注意的是，泄露的方式非常『外行』——没有剪辑、没有消音，甚至连开场寒暄都保留着。",
          "这种近乎笨拙的处理方式，反而让录音的可信度成为讨论焦点。目前当事各方均未否认录音真实性。",
        ],
      },
    ],
  },
  {
    slug: "offshore-layers",
    title: "离岸账户的第七层：一家老牌商社如何把利润搬出本土",
    excerpt:
      "七个层级的控股结构，最终指向一个只有一间信箱办公室的地址。追踪这笔资金，需要先弄懂一张看了会头晕的组织图。",
    category: "mogul",
    tags: ["离岸架构", "关联交易", "商社"],
    author: "编辑部 · 陆遥",
    date: "2026-09-03",
    readTime: 13,
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20photograph%20of%20stacked%20corporate%20documents%20and%20a%20desk%20lamp%20in%20a%20dark%20office%2C%20warm%20amber%20glow%2C%20muted%20brown%20tones%2C%20shallow%20depth%20of%20field%2C%20editorial%20documentary%20mood&width=1200&height=800&seq=meiri-executive-03&orientation=landscape",
    coverAlt: "暗色办公室里的成堆公司文件与台灯，用于财阀内幕专题配图",
    heat: 7450,
    featured: true,
    sections: [
      {
        id: "s1",
        heading: "七层结构的意义",
        paragraphs: [
          "从表面看，这只是常见的跨境持股安排。但当我们把每一层注册地、董事名单与年报披露口径并排放在一张表上，就会发现一个刻意的规律：每一层都只披露到下一层，从不穿透到底。",
          "这种设计并不违法，但它的效果很明确——让外部观察者很难在公开材料中判断，最终受益人与母公司之间到底隔了多少道墙。",
        ],
      },
      {
        id: "s2",
        heading: "那间信箱办公室",
        paragraphs: [
          "第七层的注册地址是一间共享办公空间，登记在该地址下的公司超过两百家具名实体。按照当地公开登记要求，这类实体无需披露实际经营内容。",
          "本社记者曾以商务咨询名义致函该地址，收到的回复来自一家第三方代理公司，对方表示『不掌握具体业务信息，仅提供注册与代收信函服务』。",
        ],
      },
      {
        id: "s3",
        heading: "利润是怎么走出去的",
        paragraphs: [
          "真正让这条链条有意义的，是中间几层的关联交易。子公司以『品牌授权费』和『咨询服务费』的名义向上一层支付款项，这两类支出在会计处理上弹性较大，也较难被外部审计逐笔复核。",
          "我们统计了三个财年的公开摘要，这两类费用的增长曲线与母公司同期在本土的应税利润下降曲线高度镜像。相关性不等于因果关系，但这组数据的走向值得进一步追问。",
        ],
      },
      {
        id: "s4",
        heading: "当事方回应",
        paragraphs: [
          "我们已将组织图与费用数据摘要发送给该商社的公关部门，询问其关联交易的定价依据与合规审查流程。截至发稿，对方仅确认收到邮件，未提供实质性答复。",
        ],
      },
    ],
  },
  {
    slug: "board-silence",
    title: "董事会的沉默十七分钟：财阀继承权之争的隐藏条款",
    excerpt:
      "会议纪要里出现了十七分钟的空白。这十七分钟里表决了一项条款，而这项条款决定了谁最终拿到了控制权。",
    category: "mogul",
    tags: ["继承权", "董事会", "表决"],
    author: "编辑部 · 陆遥",
    date: "2026-08-21",
    readTime: 10,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20photo%20of%20an%20empty%20boardroom%20with%20leather%20chairs%20and%20a%20single%20sealed%20envelope%20on%20the%20table%2C%20soft%20window%20light%2C%20sepia%20neutral%20tones%2C%20understated%20mood&width=1200&height=800&seq=meiri-executive-04&orientation=landscape",
    coverAlt: "空置的董事会会议室与桌上的密封信封，用于财阀内幕专题配图",
    heat: 6120,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "一段对不上的纪要",
        paragraphs: [
          "董事会纪要通常按议程逐项记录表决结果。但这一份纪要在审议继承安排时，出现了一段长达十七分钟的空白——没有讨论摘要，没有表决记录，只有一个编号为『附则三』的条目。",
          "我们比对了同一次会议的两份不同版本纪要，发现内部版本的附则三附有完整文本，而对外披露版本只保留了标题。",
        ],
      },
      {
        id: "s2",
        heading: "附则三写了什么",
        paragraphs: [
          "根据我们获得的部分文本，附则三设定了一项特别表决权：在特定条件下，家族信托持有的股份表决权可以临时集中到单一受托人手中，有效期最长三年。",
          "换句话说，这是一把为应对家族内部分歧而预留的『钥匙』。谁能拿到它，谁就在实际控制权上领先一步。",
        ],
      },
      {
        id: "s3",
        heading: "为什么现在才被翻出来",
        paragraphs: [
          "条款本身并无不当，问题在于披露。两份纪要口径不一致，意味着外部股东在关键信息上被延迟获知。这已经引发部分机构投资者的书面质询。",
          "目前集团方面回应称，对外版本『基于商业保密需要做了必要节选』，但未解释为何附则三需要整体隐去。",
        ],
      },
    ],
  },
  {
    slug: "bidding-signature",
    title: "招标书上的同一个签名：市政工程连环转包调查手记",
    excerpt:
      "五家投标公司，四个联系号码，一个签名。看似竞争充分的招标，背后是一条被拆得很细的转包链。",
    category: "corruption",
    tags: ["招标", "转包", "利益输送"],
    author: "编辑部 · 崔明",
    date: "2026-09-08",
    readTime: 12,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20documentary%20image%20of%20construction%20blueprints%20and%20a%20hardhat%20on%20a%20concrete%20floor%2C%20overcast%20cold%20light%2C%20muted%20gray%20and%20rust%20tones%2C%20slightly%20desaturated%20editorial%20style&width=1200&height=800&seq=meiri-executive-05&orientation=landscape",
    coverAlt: "混凝土地面上的工程图纸与安全帽，用于官员贪腐专题配图",
    heat: 9180,
    featured: true,
    sections: [
      {
        id: "s1",
        heading: "看起来是五家，其实是一家",
        paragraphs: [
          "项目的投标人名单里有五家公司，注册资本、成立年份各不相同，看起来竞争充分。但只要把投标文件的联系方式一栏拉出来，就会发现四家公司留的是同一组号码，其中三家的授权代表签名笔迹几乎一致。",
          "这种安排在招投标领域并不新鲜，通常被用来满足『最低投标人数』的合规要求。真正值得追的是中标之后发生了什么。",
        ],
      },
      {
        id: "s2",
        heading: "转包链的三次拆解",
        paragraphs: [
          "中标公司拿到合同后，在两周内把工程拆成三个标段向外发包。第二次转包时，其中两个标段又被打包给同一家新注册的劳务公司，而这家公司的注册地址，正是中标公司一位项目负责人的亲属住址。",
          "到施工阶段，实际的现场管理已经与中标公司几乎没有直接关系。工程质量与安全责任的归属，也随之变得模糊。",
        ],
      },
      {
        id: "s3",
        heading: "监管记录里的空白",
        paragraphs: [
          "按规定，重大转包需要备案。我们在公开平台检索该项目，只找到第一次转包的备案记录，后两次均无登记。相关审批部门尚未就备案缺失作出说明。",
          "本刊已向建设单位与主管部门发送问询函，栏目将持续更新进展。",
        ],
      },
    ],
  },
  {
    slug: "dinner-receipt",
    title: "饭局账单上的第三只手：一桩被压了三年的批文交易",
    excerpt:
      "一张消费金额异常整齐的餐饮发票，牵出一份迟迟未批的许可。三年过去，审批系统里那条状态注释依然停在原地。",
    category: "corruption",
    tags: ["批文", "发票", "审批流程"],
    author: "编辑部 · 沈郁",
    date: "2026-08-18",
    readTime: 8,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20still%20life%20of%20a%20restaurant%20receipt%20and%20a%20glass%20on%20a%20dark%20table%2C%20warm%20low%20candlelight%2C%20rich%20browns%20and%20amber%2C%20cinematic%20shallow%20focus%2C%20editorial%20magazine%20aesthetic&width=1200&height=800&seq=meiri-executive-06&orientation=landscape",
    coverAlt: "暗色桌面上的餐饮账单与酒杯，用于官员贪腐专题配图",
    heat: 6890,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "数字太整齐了",
        paragraphs: [
          "这张发票的金额是整数，没有任何零头，而同一家餐馆同期其他账单几乎都有尾数。更巧的是，这个整数恰好与一份审批事项的评估费用标准相近。",
          "发票的开具时间在申请提交之后、批复下达之前。这个时间点，通常是流程中最不适合与利益相关方见面的阶段。",
        ],
      },
      {
        id: "s2",
        heading: "被按下的三年",
        paragraphs: [
          "申请人在第三年重新提交了同样的材料，系统里显示的状态仍是『待补充说明』。而这份材料的补充要求，在现行规则中并无明确依据。",
          "多名曾在该部门任职的人员向本刊表示，此类长期挂起的情形，通常意味着一线人员不愿意签字放行，却又找不到拒绝的书面理由。",
        ],
      },
      {
        id: "s3",
        heading: "我们掌握了什么、还没掌握什么",
        paragraphs: [
          "可以确认的是发票存在、时间线重合、审批长期停滞。尚未确认的是这张账单的付款人究竟是谁，以及它与审批停滞之间是否存在直接关联。",
          "我们已通过公开渠道申请查阅该笔费用的报销记录，等待答复中。",
        ],
      },
    ],
  },
  {
    slug: "blackout-count",
    title: "计票夜的两次断电：地方选区异常票差复盘",
    excerpt:
      "同一小时内两次短暂断电，计票系统重启后的数字出现了不寻常的跳跃。我们把每一轮播报的数据都抄了下来。",
    category: "election",
    tags: ["计票", "票差", "系统重启"],
    author: "编辑部 · 何嘉",
    date: "2026-09-01",
    readTime: 11,
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20dim%20counting%20hall%20with%20stacked%20ballot%20boxes%20and%20an%20unlit%20screen%2C%20cool%20neutral%20light%2C%20restrained%20documentary%20tone%2C%20slight%20grain&width=1200&height=800&seq=meiri-executive-07&orientation=landscape",
    coverAlt: "昏暗计票大厅与堆叠的票箱，用于选举黑幕专题配图",
    heat: 10240,
    featured: true,
    sections: [
      {
        id: "s1",
        heading: "把每一轮播报抄下来",
        paragraphs: [
          "计票夜官方会分批次播报结果。我们把当晚每一次播报的时间、票数与累计百分比逐条记录，形成一条完整序列。这样做的好处是，任何一次异常跳跃都会在序列里留下痕迹。",
          "两次断电分别发生在晚间两次播报之间。重启之后的下一轮数据，增量明显偏离了此前的线性趋势。",
        ],
      },
      {
        id: "s2",
        heading: "偏离有多少",
        paragraphs: [
          "在断电之前，两个候选人的领先幅度在缓慢收窄，符合该选区历史上的票仓结构。断电重启后，原本收窄的趋势被一次性抹平，并出现了反向的跳变。",
          "需要说明的是，票数跳变本身并不等于舞弊，人工计票批次补录、邮寄票集中录入都可能造成类似曲线。关键在于官方是否提供了与跳变相匹配的批次说明。",
        ],
      },
      {
        id: "s3",
        heading: "缺失的批次说明",
        paragraphs: [
          "我们已向选举管理机构申请查阅当晚的批次录入日志与设备重启记录。截至发稿，仅收到自动回复。",
          "如果批次说明能够公开并对上时间线，这一疑点即可排除；如果不能，那么复盘就必须继续。",
        ],
      },
    ],
  },
  {
    slug: "erased-poll",
    title: "被删除的民调：一份内部备忘录里的选情操控清单",
    excerpt:
      "备忘录列了七家机构的名字，标注了每家应『延后发布』的时间点。这份清单如果属实，投票前最后两周的信息环境是被精心安排过的。",
    category: "election",
    tags: ["民调", "信息操控", "备忘录"],
    author: "编辑部 · 何嘉",
    date: "2026-08-14",
    readTime: 9,
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20photo%20of%20torn%20polling%20charts%20and%20a%20marker%20on%20a%20plain%20desk%2C%20soft%20diffused%20light%2C%20muted%20beige%20and%20slate%20tones%2C%20clean%20editorial%20composition&width=1200&height=800&seq=meiri-executive-08&orientation=landscape",
    coverAlt: "桌上被撕开的民调图表与记号笔，用于选举黑幕专题配图",
    heat: 7320,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "清单的样子",
        paragraphs: [
          "备忘录以表格形式列出七家民调机构，右侧一栏写着『建议窗口』，内容包括『延后至第二周』『避免单日连发』等表述。文末有一句手写批注：『节奏比数字重要』。",
          "我们无法独立验证这份文件的来源与完整性，因此将其作为线索而非结论呈现。",
        ],
      },
      {
        id: "s2",
        heading: "历史上是否真的这样发生",
        paragraphs: [
          "把七家机构在选举前四周的发布节奏拉出来看，确实有两家在标识的时间段内没有发布任何结果，另有一家的发布时间比其历史规律晚了五天。",
          "这组吻合度值得注意，但样本很小，也可能只是机构自身的排期安排。我们不做过度推断。",
        ],
      },
      {
        id: "s3",
        heading: "下一步的核查路径",
        paragraphs: [
          "要判断这份备忘录是否真实被使用，需要两个材料：一是各机构的内部排期审批记录，二是竞选团队的内部通讯。两者都难以通过公开渠道获得。",
          "我们已将文件影像（隐去可能暴露来源的边角信息）提交给两家第三方事实核查机构，等待其技术评估意见。",
        ],
      },
    ],
  },
  {
    slug: "empty-warehouse",
    title: "财报里的空仓库：零售巨头的营收虚增路径图",
    excerpt:
      "仓库的监控记录显示，连续三个季度的出货量都远低于财报口径。多出来的那部分营收，究竟记在了哪里？",
    category: "corporate",
    tags: ["财报", "营收虚增", "审计"],
    author: "编辑部 · 苏彦",
    date: "2026-09-05",
    readTime: 14,
    cover:
      "https://readdy.ai/api/search-image?query=wide%20editorial%20photo%20of%20a%20vast%20empty%20warehouse%20with%20bare%20shelves%20and%20one%20pallet%2C%20cold%20industrial%20lighting%2C%20desaturated%20blue-gray%20neutral%20tones%2C%20restrained%20documentary%20mood&width=1200&height=800&seq=meiri-executive-09&orientation=landscape",
    coverAlt: "空旷的仓库货架与孤零零的托盘，用于企业造假专题配图",
    heat: 8890,
    featured: true,
    sections: [
      {
        id: "s1",
        heading: "出货量与营收的落差",
        paragraphs: [
          "按照财报附注的物流口径，该零售集团在三个季度内累计出货量约为一百二十万件。但同一时期，主要仓储基地的出入库记录合计不足八十万件。",
          "两者相差约四十万件。财报并未解释这部分差额来自何处，附注中仅提到『部分区域采用代为配送模式』，没有给出具体占比。",
        ],
      },
      {
        id: "s2",
        heading: "『代为配送』是不是答案",
        paragraphs: [
          "我们联系了两家被点名的区域配送合作方，其中一家表示合作规模『每月不超过两千单』，另一家则称双方的合作已在更早的财年终止。",
          "如果这两家的说法属实，那么代为配送模式所能覆盖的量级，远不足以填补四十万件的差额。",
        ],
      },
      {
        id: "s3",
        heading: "收入确认的口径",
        paragraphs: [
          "另一个可能的方向是收入确认时点。零售行业常见的做法是在货物离仓时确认收入，若采用更宽松的『订单生成即确认』口径，就会在账面上形成时间差。",
          "我们查阅了其近三份年报，收入确认政策表述在中间一年发生过一次措辞微调，但未作为会计政策变更单独披露。这一细节值得审计方说明。",
        ],
      },
      {
        id: "s4",
        heading: "公司回应与后续",
        paragraphs: [
          "集团投资者关系部门回应称，仓储数据『不构成对外的财务口径，不能直接与营收比较』。这一表述在逻辑上成立，但也意味着外部目前无法验证差额来源。",
          "本刊已向负责其年报审计的会计师事务所提出问询，并将在获得答复后更新本文。",
        ],
      },
    ],
  },
  {
    slug: "twin-report",
    title: "质检报告的双胞胎：一家零部件厂商的批次调包术",
    excerpt:
      "两个批次的检测报告，编号不同、日期不同，但连标点符号的位置都一样。唯一的区别，是那份没通过的结果被换掉了。",
    category: "corporate",
    tags: ["质检", "批次", "供应链"],
    author: "编辑部 · 苏彦",
    date: "2026-08-25",
    readTime: 10,
    cover:
      "https://readdy.ai/api/search-image?query=close%20editorial%20shot%20of%20metal%20machine%20parts%20beside%20a%20laboratory%20report%20sheet%2C%20cool%20neutral%20light%2C%20industrial%20desaturated%20palette%2C%20clean%20restrained%20composition%2C%20slight%20grain&width=1200&height=800&seq=meiri-executive-10&orientation=landscape",
    coverAlt: "金属零部件与旁边的检测报告单，用于企业造假专题配图",
    heat: 5980,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "两份报告的相似度",
        paragraphs: [
          "检测报告的格式通常由第三方实验室生成，措辞会有细微差别。但这两份报告除了批次号、日期与结论之外，连描述性段落的断句位置都完全一致。",
          "我们请一位有十年经验的实验室主管做了盲评，对方的第一反应是：『这不是两份独立报告，是一份改了数字。』",
        ],
      },
      {
        id: "s2",
        heading: "哪一份是真的",
        paragraphs: [
          "通过实验室官网的在线验证入口，只有其中一份的编号可以返回有效结果，另一份显示『未查询到该编号』。无法验证的那一份，恰恰结论为『合格』。",
          "这意味着，流向整车厂的合格报告，可能并未经过该实验室的实际出具流程。",
        ],
      },
      {
        id: "s3",
        heading: "供应链端的风险",
        paragraphs: [
          "该批次零部件被用于至少两个车型的安全相关部件。如果合格结论建立在一份无效报告之上，质量风险就不是一家厂商的问题。",
          "我们已同时向整车厂与市场监管部门提交了编号比对结果，等待核查启动。",
        ],
      },
    ],
  },
  {
    slug: "lab-swap",
    title: "实验室里的移花接木：一篇高被引论文的图像疑点复现",
    excerpt:
      "同一张凝胶图出现在两篇不同论文的不同实验组里。把亮度调回原始参数后，拼接的接缝清晰可见。",
    category: "academic",
    tags: ["图像复用", "论文", "科研诚信"],
    author: "编辑部 · 林澈",
    date: "2026-08-30",
    readTime: 12,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20photo%20of%20a%20dim%20research%20laboratory%20bench%20with%20pipettes%20and%20a%20glowing%20screen%2C%20cool%20neutral%20tones%2C%20restrained%20documentary%20style%2C%20subtle%20grain&width=1200&height=800&seq=meiri-executive-11&orientation=landscape",
    coverAlt: "昏暗实验室操作台上的移液器与亮着的屏幕，用于学术不端专题配图",
    heat: 5340,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "从一张图开始",
        paragraphs: [
          "我们最初的注意点很偶然：论文中的一张凝胶电泳图，条带排列与另一篇更早发表的文章高度相似，但两篇文章研究的是完全不同的细胞类型。",
          "把两张图叠加后做差值运算，背景噪声的分布几乎完全重合。独立拍摄的两张凝胶图，很难出现这种级别的噪声一致性。",
        ],
      },
      {
        id: "s2",
        heading: "复现的过程",
        paragraphs: [
          "我们把论文提供的原始图像文件下载后，调整对比度与伽马值。在拉伸对比度之后，图中出现了明显的矩形拼接缝，边界处的像素分布不连续。",
          "这不是压缩产生的伪影——压缩伪影沿块状边界分布，而这里的不连续是沿一条笔直的分割线，更像后期拼接留下的痕迹。",
        ],
      },
      {
        id: "s3",
        heading: "期刊与作者的反应",
        paragraphs: [
          "我们已将对比图与分析方法发送给期刊编辑部与该论文的通讯作者。期刊方面确认收到并启动调查程序，作者团队暂未公开回应。",
          "需要注意的是，图像疑点并不必然等同于数据造假，也可能是图版整理时的失误。但无论原因如何，结论的可信度都需要重新评估。",
        ],
      },
    ],
  },
  {
    slug: "review-circle",
    title: "评审名单上的熟面孔：学术评审闭环是如何形成的",
    excerpt:
      "同一批人在两年内审了彼此七十余篇稿件。当评审圈足够小，『同行评议』这四个字还能剩下多少独立性？",
    category: "academic",
    tags: ["同行评议", "评审", "小圈子"],
    author: "编辑部 · 林澈",
    date: "2026-08-11",
    readTime: 9,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20image%20of%20an%20academic%20journal%20stack%20with%20a%20pair%20of%20glasses%20and%20an%20open%20review%20form%20on%20a%20library%20table%2C%20warm%20muted%20light%2C%20understated%20composition&width=1200&height=800&seq=meiri-executive-12&orientation=landscape",
    coverAlt: "图书馆桌上的学术期刊与敞开的评审表，用于学术不端专题配图",
    heat: 4210,
    featured: false,
    sections: [
      {
        id: "s1",
        heading: "数据是怎么算出来的",
        paragraphs: [
          "我们把某学科领域公开的评审致谢名单整理成关系表，用两年时间跨度统计谁审了谁。结果显示，有二十三位学者构成了一个高频互审群体，内部互审稿件超过七十篇。",
          "互审本身无可厚非——小领域里专家本就有限。问题在于，这个群体的成员是否同时担任了期刊的编委或编审决策角色。",
        ],
      },
      {
        id: "s2",
        heading: "角色重叠的后果",
        paragraphs: [
          "在统计的二十三人中，有十一人同时是至少一本相关期刊的编委会成员。这意味着他们既参与稿件分配，又参与评审意见形成，还可能影响最终录用决策。",
          "角色重叠会削弱同行评议的核心假设：评审人与作者之间应当保持必要的独立距离。",
        ],
      },
      {
        id: "s3",
        heading: "学界已有的讨论",
        paragraphs: [
          "部分期刊近年已开始要求编委回避同机构或近期合作过的稿件，但回避规则在各刊之间差异很大，且执行情况不透明。",
          "我们已就统计方法与该群体的编辑角色向相关期刊发出询问，期待获得进一步说明。",
        ],
      },
    ],
  },
];